import { render, staticRenderFns } from "./AutoCollectItem.vue?vue&type=template&id=ab5bce50&scoped=true"
import script from "./AutoCollectItem.vue?vue&type=script&lang=js"
export * from "./AutoCollectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5bce50",
  null
  
)

export default component.exports